import React, { useMemo } from "react"

import { StatsigProvider } from "@statsig/react-bindings"
import { LoadingSpin } from "../page-subscription-checkout/styled-index"
import { featureManager } from "../../utils/feature-flag"

export const FeatureFlagProvider = ({ children }) => {
  const statsigInstance = useMemo(() => featureManager.getStatsigInstance(), [])

  return (
    <StatsigProvider
      client={statsigInstance}
      loadingComponent={<LoadingSpin />}>
      {children}
    </StatsigProvider>
  )
}
